__webpack_require__.p = "/gzbndetail/";